import { getClient } from '../../../../app/redux/context';
import { setTrendSelector } from 'features/groups/analysis/redux';
import { getGroupAccessRecords } from '../../../../groups/setup/redux/selectors';
import { calculateSummitKeyStage } from '../../../../../utils/summitKeyStage';
import { getCurrentAcademicYear, academicYearLongName } from '../../../../../utils/academicYear';

export const setDefualtTrendSelectorValues = (): AppThunk => async (dispatch, getState) => {
	const clientAccess = getClient(getState());
	const accessRecords = getGroupAccessRecords(getState());

	const yearOptions = accessRecords.map((options: any) => options.academicYear);
	const currentAcademicYear = getCurrentAcademicYear();

	const defaultValue = accessRecords
		//default to the groupAccess of the clients intial context
		//could be KeyStage 4 or 5 depending on contract
		.filter((x) => x.id === clientAccess?.groupAccessId)
		.map((y) => {
			return {
				label: calculateSummitKeyStage(y.examLevel),
				value: y.id,
			};
		})[0];

	const academicYearDefualtValue = accessRecords
		//default to the groupAccess of the clients intial context
		//could be KeyStage 4 or 5 depending on contract
		.filter((x) => x.id === clientAccess?.groupAccessId)
		.map((y) => {
			return {
				label: academicYearLongName(y.academicYear),
				value: y.id,
			};
		})[0];

	const academicYearOptions = accessRecords
		.filter((value, index) => {
			return (
				yearOptions.indexOf(value.academicYear) === index &&
				value.academicYear <= currentAcademicYear
			);
		})
		.sort((a, b) => Number(a.academicYear) - Number(b.academicYear))
		.map((x) => {
			return {
				label: academicYearLongName(x.academicYear),
				value: x.id,
			};
		});

	const keyStageOptions = accessRecords
		.filter((y) => academicYearLongName(y.academicYear) === academicYearDefualtValue?.label)
		.map((x) => {
			return {
				label: calculateSummitKeyStage(x.examLevel),
				value: x.id,
			};
		});

	dispatch(
		setTrendSelector({
			availableYears: academicYearOptions,
			selectedYear: academicYearDefualtValue,
			availableKeyStages: keyStageOptions,
			selectedKeyStage: defaultValue,
		})
	);
};
